"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var asg_1 = require("@alinta-digital/asg");
var TotalBalanceLabel = function () {
    return (react_1.default.createElement(asg_1.Text, { size: "medium", "data-testid": "totalBalanceLabel", color: asg_1.colors['dark-7'], weight: 500 }, "Total balance"));
};
exports.default = TotalBalanceLabel;
//# sourceMappingURL=TotalBalanceLabel.js.map